import React from "react";
import { makeStyles } from "@mui/styles";
import ImageIcon from "../Icon/ImageIcon";

const styles = makeStyles({
  button: {
    backgroundColor: "white",
    border: "1px solid #d3dae3",
    borderRadius: "4px",
    fontFamily: "inter_400",
    padding: "0.25rem 1rem",
    display: "flex",
    fontSize: "14px",
    margin: "5px 10px",
    color: "#626b7e",
    cursor: "pointer",
    alignItems: "center",
  },
  icon: {
    marginRight: ".2rem",
  },
  secondIcon: {
    alignSelf: "center",
  },
});

const TableSaveBtn = ({ message, icon, secondIcon }) => {
  const classes = styles();

  return (
    <button className={classes.button}>
      {icon && <ImageIcon image={icon} />}
      {message}
      {secondIcon ? <ImageIcon image={secondIcon} /> : null}
    </button>
  );
};

export default TableSaveBtn;
